module.exports = __webpack_public_path__ + "img/icon-sb-buy-now-mob.ab2939a.svg";